{
    "ClientConfigurationModal_AddTitle": "Adicionar configuração do cliente",
    "ClientConfigurationModal_ChangeTitle": "Alterar configuração do cliente",
    "ClientConfigurationModal_Footer_Actions_Submit": "Enviar",
    "ClientConfigurationModal_Footer_Actions_Cancel": "Cancelar",
    "ClientConfigurationModal_Footer_Actions_Help": "Ajuda",
    "ClientConfigurationModal_Tabs_Details": "Detalhes",
    "ClientConfigurationModal_Tabs_Scope": "Âmbito",
    "ClientConfigurationModal_Tabs_Policy": "Política",
    "ClientConfigurationModal_Tabs_Settings": "Definições",
    "ClientConfigurationModal_Tab_Details_Description": "Descrição",
    "ClientConfigurationModal_Tab_Details_Description_Required": "Descrição é necessária",
    "ClientConfigurationModal_Tab_Details_ID": "EU IA",
    "ClientConfigurationModal_Tab_Details_ID_Placeholder": "[Atribuição automática]",
    "ClientConfigurationModal_Tab_Details_Override": "Substituir todas as configurações do cliente",
    "ClientConfigurationModal_Tab_Scope_CME": "CME",
    "ClientConfigurationModal_Tab_Scope_Telsys": "Servidor de Telefonia",
    "ClientConfigurationModal_Tab_Scope_Telsys_Required": "Servidor de telefonia é necessário",
    "ClientConfigurationModal_Tab_Scope_Partition": "Partição",
    "ClientConfigurationModal_Tab_Scope_Device": "Dispositivo",
    "ClientConfigurationModal_Tab_Scope_FilterRecursive": "Filtrar recursivamente",
    "ClientConfigurationModal_Tab_Policy_PolicyItem": "Item de política",
    "ClientConfigurationModal_Tab_Policy_DefaultValue": "Valor padrão",
    "ClientConfigurationModal_Tab_Policy_ActualValue": "Valor real",
    "ClientConfigurationModal_Policy_core": {
        "showUseConfigurationWindow": "Núcleo - Pode mostrar\/usar janela de configuração",
        "permittedToLogin": "Núcleo - Permissão para iniciar sessão"
    },
    "ClientConfigurationModal_Policy_configOptions": {
        "useLocalhostAPI": "Configuração - usar API Localhost",
        "canConfigureCustomEvents": "Config - Configurar eventos personalizados"
    },
    "ClientConfigurationModal_Policy_menuOptions": {
        "canShowAddressBook": "Menu - Catálogo de Endereços"
    },
    "ClientConfigurationModal_Policy_crm": {
        "canAddNewContacts": "Pode adicionar novos contactos aos CRMs (por meio do assistente)"
    },
    "ClientConfigurationModal_Tab_Settings_SettingsItem": "Opção de definição",
    "ClientConfigurationModal_Tab_Settings_DefaultValue": "Valor padrão",
    "ClientConfigurationModal_Tab_Settings_ActualValue": "Valor real",
    "ClientConfigurationModal_Settings_interface": {
        "showCallNotificationPreview": "Interface - Mostrar pré-visualização de notificação de chamada",
        "showMissedCallPreview": "Interface - Mostrar pré-visualização de chamadas perdidas",
        "connectedHideDelay": "Interface - Atraso de Ocultação Ligado",
        "previewWindowAlwaysOnTop": "Interface - Janela de pré-visualização sempre no topo",
        "showContactInEditMode": "Interface - Mostrar contacto no modo de edição",
        "applicationLoadAtWindowsStartup": "Interface - Carregamento da aplicação na inicialização do Windows"
    },
    "ClientConfigurationModal_Settings_hotkey": {
        "makeCall": "Tecla de atalho - Fazer chamada"
    },
    "ClientConfigurationModal_Settings_dialing": {
        "clipboardDialing": "Marcação - Marcação da área de transferência",
        "focusDialing": "Marcação - Marcação de foco",
        "screenDialing": "Marcação - Marcação de ecrã"
    },
    "ClientConfigurationModal_Settings_logPage": {
        "sendAnonymouseStats": "Página de Log - Enviar estatísticas anónimas",
        "loggingLevel": "Página de Log - Nível de Log",
        "sendAnonymousStats": "Página de Log - Enviar estatísticas anónimas"
    },
    "ClientConfigurationModal_Settings_version": {
        "checkForUpdates": "Versão - Verificar atualizações e Descarregar"
    },
    "NAME": "ClientConfigurationModalLanguage",
    "ClientConfigurationModal_Error_NotFound": "Configuração do cliente não encontrada ou inexistente"
}